<template>
  <div ref="rootRef" class="collage-carousel">
    <!-- FONDO ROSA -->
    <div class="rasgado rasgado-top"></div>

    <div ref="bgRef" class="bg-rosa"></div>

    <!-- 🌸 FLORES -->
    <img src="@/assets/lineas2.png" class="flor flor-lt" />
    <img src="@/assets/lineas2.png" class="flor flor-lb" />
    <img src="@/assets/lineas2.png" class="flor flor-rt" />
    <img src="@/assets/lineas2.png" class="flor flor-rb" />

    <!-- IMÁGENES -->
    <div class="collage-grid">
      <div
        v-for="(image, index) in images"
        :key="index"
        ref="collageItems"
        class="collage-item"
        @click="enlargeImage(index)"
      >
        <img
          :src="image"
          class="collage-image"
          :alt="'Imagen ' + index"
        />
      </div>
    </div>

    <!-- MODAL -->
    <div
      v-if="isImageEnlarged"
      class="image-modal"
      @click="closeModal"
    >
      <img
        :src="images[currentIndex]"
        class="enlarged-image"
      />
    </div>

    <div class="rasgado rasgado-inferior"></div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CollageAnimadoMagico',

  setup() {

    const images = [
      require('@/assets/2E0A1198.jpg'),
      require('@/assets/2E0A1217.jpg'),
      require('@/assets/2E0A1295.jpg'),
    ]

    const rootRef = ref(null)
    const bgRef = ref(null)
    const collageItems = ref([])

    const currentIndex = ref(0)
    const isImageEnlarged = ref(false)

    const enlargeImage = (index) => {
      currentIndex.value = index
      isImageEnlarged.value = true
    }

    const closeModal = () => {
      isImageEnlarged.value = false
    }

    onMounted(async () => {

      await nextTick()

      collageItems.value = collageItems.value.slice(0, images.length)

      const flores = rootRef.value.querySelectorAll('.flor')

      /* ESTADOS INICIALES */
      gsap.set(bgRef.value, { opacity: 0 })

      gsap.set(flores, {
        opacity: 0,
        scale: 0.9,
        y: 20
      })

      gsap.set(collageItems.value, {
        opacity: 0
      })

      const io = new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

          if (!entry.isIntersecting) return

          const tl = gsap.timeline({
            defaults: {
              ease: 'power3.out'
            }
          })

          /* FONDO */
          tl.to(bgRef.value, {
            opacity: 1,
            duration: 0.45
          })

          /* FLORES */
          tl.to(
            flores,
            {
              opacity: 0.55,
              scale: 1,
              y: 0,
              rotate: () => gsap.utils.random(-6, 6),
              duration: 0.55,
              stagger: 0.1
            },
            '+=0.15'
          )

          /* FLORES FLOTANDO */
          flores.forEach((flor, i) => {

            gsap.to(flor, {
              y: `+=${gsap.utils.random(6, 12)}`,
              rotate: gsap.utils.random(-4, 4),
              duration: gsap.utils.random(3, 4),
              repeat: -1,
              yoyo: true,
              ease: 'sine.inOut',
              delay: i * 0.25
            })

          })

          /* TODAS LAS FOTOS */
          collageItems.value.forEach((item, i) => {

            tl.fromTo(
              item,
              {
                opacity: 0,
                y: 70,
                scale: 0.96
              },
              {
                opacity: 1,
                y: 0,
                scale: 1,
                duration: 0.9
              },
              i === 0 ? '+=0.2' : '-=0.45'
            )

          })

          io.disconnect()

        })

      }, {
        threshold: 0.2
      })

      if (rootRef.value) {
        io.observe(rootRef.value)
      }

    })

    return {
      images,
      rootRef,
      bgRef,
      collageItems,
      currentIndex,
      isImageEnlarged,
      enlargeImage,
      closeModal
    }
  }
}
</script>


<style scoped>
.collage-carousel {
  position: relative;
  width: 100%;
  min-height: 70vh;
  margin-top: -40px;
  margin-bottom: -40px;
  overflow: hidden;
}

/* FONDO ROSA */
.bg-rosa {
  position: absolute;
  inset: 0;
    background: rgb(28, 28, 28);

  z-index: 0;
}

/* 🌸 FLORES */
.flor {
  position: absolute;
  width: 590px;
  height: 110px;  opacity: 0;
  pointer-events: none;
  z-index: 1;
}

.flor-lt { top: -16vh; left: -45px; }
.flor-lb { bottom: 6vh; left: -55px; }
.flor-rt { top: 8vh; right: -45px; }
.flor-rb { bottom: 6vh; right: -55px; }

/* GRID */
.collage-grid {
  position: relative;
  z-index: 2;  margin-top:190px;

  display: grid;
  grid-template-columns: repeat(12, 1fr);
  padding-top: 6vh;
  padding-bottom: 6vh;
}

/* ITEM */
.collage-item {
  grid-column: span 12;
  opacity: 0;
  cursor: pointer;
  margin-bottom: 10vh; /* ✨ ESPACIO ENTRE IMÁGENES */
}

/* IMAGEN */
.collage-image {
  width: 100%;
  display: block;
  object-fit: contain;
  transition: transform 0.4s ease;
}

.collage-image:hover {
  transform: scale(1.03);
}

/* MODAL */
.image-modal {
  position: fixed;
  inset: 0;
  background: rgba(10, 10, 10, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.enlarged-image {
  max-width: 90%;
  max-height: 90%;
  border-radius: 12px;
}

/* ===== Rasgados ===== */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 50px;

  background: rgb(28, 28, 28);
  z-index: 12;
  pointer-events: none;
}
.rasgado-top {
  top: 0;
}


.rasgado-inferior {
  bottom: 0;
  background: rgb(28, 28, 28);
  clip-path: polygon(
    0% 80%,
    25% 60%,
    50% 85%,
    75% 55%,
    100% 75%,
    100% 0%,
    0% 0%
  );
}


</style>
